<template>
	<v-dialog v-model="dialog" persistent max-width="1200px" scrollable>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				v-bind="attrs"
				v-on="on"
				color="primary"
				dark
				@click="mark_as_accepted()"
				:loading="item.processing"
				block
			>
				{{ $t("label.mark_as_accepted") }}
			</v-btn>
		</template>
		<v-form>
			<v-card>
				<v-card-title primary-title>
					<span
						v-html="
							$t('title.accept_order', {
								args: { code: order.code },
							})
						"
					>
					</span>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-layout row wrap class="py-2 px-2">
						<v-flex xs12 md12>
							<v-simple-table>
								<template v-slot:default>
									<thead>
										<tr>
											<th class="text-left" width="50">
												&nbsp;
											</th>
											<th class="text-left">
												{{ $t("label.item") }}
											</th>
											<th class="text-left" width="100">
												{{ $t("label.quantity") }}
											</th>
											<th class="text-left">
												{{ $t("Price") }}
											</th>
											<th class="text-left">
												{{ $t("Subtotal") }}
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(line, index) in item.lines"
											:key="index"
											:class="{
												'red lighten-5':
													line.available_quantity <
														line.quantity &&
													line.is_available,
											}"
										>
											<td>
												<v-checkbox
													v-model="line.is_available"
												></v-checkbox>
											</td>
											<td>
												<a
													:href="
														$route(
															'tenant.products.show',
															{
																tenant: $page
																	.props
																	.tenant.id,
																product:
																	line.product_uuid,
															}
														)
													"
													target="_blank"
												>
													{{ line.product_name }}
													<v-icon right small>
														mdi-open-in-new
													</v-icon>
												</a>
												<p v-if="line.note">
													<code
														class="
															red
															lighten-4
															text-caption
														"
													>
														{{ line.note }}
													</code>
												</p>
												<p v-if="line.unavailable">
													<code class="text-caption">
														{{ line.unavailable }}
													</code>
												</p>
											</td>
											<td>
												<v-select
													v-model="
														line.available_quantity
													"
													:items="
														getQuantityItems(
															line.quantity
														)
													"
													dense
													hide-details
													single-line
												></v-select>
											</td>
											<td>
												{{ line.price | currency }}
											</td>
											<td>
												{{
													(line.quantity * line.price)
														| currency
												}}
											</td>
										</tr>
									</tbody>
									<tfoot>
										<tr>
											<td colspan="3">&nbsp;</td>
											<td class="text-right">
												<strong>
													{{ $t("Subtotal") }}
												</strong>
											</td>
											<td>
												<strong>
													{{ total | currency }}
												</strong>
											</td>
										</tr>
										<tr>
											<td colspan="3">&nbsp;</td>
											<td class="text-right">
												<strong>
													{{ $t("Total") }}
												</strong>
											</td>
											<td>
												<strong>
													{{ order.total | currency }}
												</strong>
											</td>
										</tr>
									</tfoot>
								</template>
							</v-simple-table>
						</v-flex>
					</v-layout>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="closeItem()">
						<v-icon left>mdi-close</v-icon>
						{{ $t("Close") }}
					</v-btn>
					<v-btn
						color="primary"
						@click.native="submit(order)"
						:loading="item.processing"
					>
						{{ $t("label.accept") }}
						<v-icon left>mdi-arrow-right</v-icon>
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<script>
export default {
	props: ["order"],
	data() {
		return {
			dialog: false,
			item: this.$inertia.form({
				order_id: this.order.id,
				lines: this.order.items,
			}),
		};
	},
	computed: {
		total() {
			var total = 0;

			this.item.lines.forEach((line) => {
				if (line.is_available) {
					total += line.available_quantity * line.price;
				}
			});

			return total;
		},
	},

	methods: {
		mark_as_accepted() {
			this.select_all = false;
			this.is_available = [];
			this.dialog = true;
		},

		closeItem() {
			this.dialog = false;
		},

		submit(order) {
			try {
				this.item.post(
					this.$route(
						"tenant.orders.mark_as_accept",
						{
							tenant: this.$page.props.tenant.id,
							order: order.uuid,
						},
						{
							order,
						}
					),
					{
						preserveState: true,
						preserveScroll: true,
					}
				);
			} catch (e) {
				this.$toast.error(e.message);
			} finally {
				this.closeItem();
			}
		},

		getQuantityItems(quantity) {
			let items = [];
			for (let i = 1; i <= quantity; i++) {
				items.push(i);
			}
			return items;
		},
	},
};
</script>